import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/main.scss';
import App from './App';
import store from './store/store';
import { Provider } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#0086ff'
        },
        white: {
            main: '#fff'
        },
        secondary:{
            main: '#fe5200'
        }
    },
    typography: {
        fontSize: 16,
    },
    tableHeaderColor:{
        isSupHeadingColor:"#DAEDFE",
        isHeadingColor:"#BFE1FF",
        isSubHeadingColor:"#f1f9ff",
        tableHeadColor:'#e5f2ff',
        isTotalColor:"#eeeeee",
        textColor:"#444444"
    },
    components: {
        MuiButton: {
            styleOverrides: {
                outlined: {
                    borderWidth: '2px',
                    fontSize:'16px'
                },
            },
        },
    },
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <App store = { store } />
        </ThemeProvider>
    </Provider>
);